import { render } from "./UrlCheck.vue?vue&type=template&id=1f8b883a"
import script from "./UrlCheck.vue?vue&type=script&lang=js"
export * from "./UrlCheck.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__